import PropTypes from 'prop-types';

const Card = incomingProps => {
  const props = {
    ...{
      style: {},
      children: null || [],
      class: '',
    },
    ...incomingProps,
  };
  return (
    <div style={props.style} className={`global-card ${props.class}`}>
      {props.children}
    </div>
  );
};

Card.propTypes = {
  style: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  class: PropTypes.string,
};

export default Card;
